(function () {
  'use strict';

  function reveal(el) { el.classList.add('is-revealed'); }

  function init() {
    var heroes = document.querySelectorAll('[data-kpm-hero]');
    if (!heroes.length) return;

    if (!('IntersectionObserver' in window)) {
      heroes.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          reveal(e.target);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

    heroes.forEach(function (h) {
      var rect = h.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.85) {
        reveal(h);
      } else {
        io.observe(h);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
